import React from "react";
import { motion } from "framer-motion/dist/framer-motion";

import {
  divVariants,
  bounce_right_to_left_variants_delay,
  bounce_right_to_left_variants_without_children
} from "shared/components/animations";

const TOTPreGuessClueGiver = ({ currentGuesser }) => {
  return (
    <motion.div
      variants={divVariants}
      initial="hidden"
      animate="visible"
      exit="exit"
      className="tot-clue-giver-preguess"
    >
      <motion.div
        variants={bounce_right_to_left_variants_without_children}
        className="top-panel-div"
      >
        <h2>The round is about to start!</h2>
        <p>
          When the round starts, help them guess as many words by giving clues
          about the word and press "Got It!" if they get it!
        </p>
      </motion.div>

      <motion.div
        variants={bounce_right_to_left_variants_delay}
        className="guesser-text"
      >
        <h2>The Current Guesser is:</h2>
      </motion.div>

      <div className="tot-guesser-img-div">
        <img
          alt=""
          className="guesser-img"
          src={currentGuesser.profile_image}
        />
      </div>

      <div className="bottom-guesser-bg">
        <h2>{currentGuesser.display_name}</h2>
      </div>
    </motion.div>
  );
};

export default TOTPreGuessClueGiver;
